import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

import soremoLogoWhite from "../../../assets/images/logo_soremo_light_gray.svg";

const OsFooterContainer = styled.footer.attrs({
  className: "u-col u-items-center",
})`
  width: 100vw;
  /* リンクが折り返しても切れないよう最小高さで持つ */
  min-height: 256px;
  padding: 0 24px 48px;
  background: var(--soremo-border);
  color: #fff;

  font-size: 11px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  gap: 16px;
`;

const FooterLogo = styled.div({
  width: "80px",
  aspectRatio: "1 / 1",
  background: `url(${soremoLogoWhite}) no-repeat center center / contain`,
  color: "#fff",
  marginTop: "64px",
});

const FooterLegal = styled.div.attrs({
  className: "u-col-center u-gap16",
})`

  @media (width < 640px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`;

const FooterLink = styled(Link)`
  text-decoration: none;
  color: #a7a8a9;

  /* BodyText 11 設定 */
  font-family: "A+mfCv-AXISラウンド 50 L StdN", "M PLUS 1p", sans-serif;
  font-weight: normal;
  font-size: 11px;
  line-height: 200%;

  /* visited状態でもスタイルを維持 */
  &:visited {
    color: #a7a8a9;
    text-decoration: none;
  }
`;

const FooterText = styled.div`
  text-decoration: none;
  color: #a7a8a9;

  /* BodyText 11 設定 */
  font-family: "A+mfCv-AXISラウンド 50 L StdN", "M PLUS 1p", sans-serif;
  font-weight: normal;
  font-size: 11px;
  line-height: 200%;
`;

const OsFooter = () => {
  return (
    <>
      <OsFooterContainer>
        <FooterLogo />
        <FooterLegal>
          <FooterText>Copyright SOREMO Co.,Ltd. All rights reserved.</FooterText>
          {/* 会社概要・法務ページは SPA 内ルート（/about /termsofservice /privacypolicy /tokushoho） */}
          <div className="u-row-center u-wrap u-gap16">
            <FooterLink to="/about">会社概要</FooterLink>
            <FooterLink to="/termsofservice">利用規約</FooterLink>
            <FooterLink to="/privacypolicy">プライバシーポリシー</FooterLink>
            <FooterLink to="/tokushoho">特定商取引法に基づく表示</FooterLink>
          </div>
        </FooterLegal>
      </OsFooterContainer>
    </>
  );
};

export default OsFooter;
